import React, { useEffect, useState } from 'react';
import HeroSection from '../components/HomePage/HeroSection';
import AllBoatsSection from '../components/HomePage/AllBoatsSection';
import CompanyTripAdvisorReviewsSection from '../components/HomePage/CompanyTripAdvisorReviewsSection';
import FAQ from '../components/HomePage/FAQ';
import OpenGraphImage from '../../images/HomePage/TravelWebKitBase_HomePageBanner.png';
import SEOHead from '../components/Common/SEOHead';
import WebPreloader from '../components/Common/WebPreloader';
import '../styles/home/HomePage.css';

const HomePage = () => {
  const [showPreloader, setShowPreloader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowPreloader(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="home-page">
      <SEOHead pageType="home" />
      <HeroSection />
      <AllBoatsSection />
      <FAQ />
      <CompanyTripAdvisorReviewsSection />
      {/* <ExclusiveOfferManager delaySeconds={5} /> */}

      {showPreloader && <WebPreloader />}
    </div>
  );
};

export default HomePage;